import { useCallback, useEffect, useRef } from "react";
import { fetchMetaPlatform } from "./useMetaGraphVersion";
import { initMetaApp } from "../helpers/metaSdk";

const useEmbeddedSignup = ({ onListo, onError }) => {
  const parcial = useRef({});

  const completar = useCallback(() => {
    const { code, wabaId } = parcial.current;
    if (!code || !wabaId) return;

    const datos = { ...parcial.current };
    parcial.current = {};
    onListo(datos);
  }, [onListo]);

  useEffect(() => {
    const alRecibir = (evento) => {
      if (!String(evento.origin || "").endsWith("facebook.com")) return;

      let datos;
      try {
        datos = typeof evento.data === "string" ? JSON.parse(evento.data) : evento.data;
      } catch {
        return;
      }

      if (datos?.type !== "WA_EMBEDDED_SIGNUP") return;

      if (datos.event === "FINISH" || datos.event === "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING") {
        parcial.current = {
          ...parcial.current,
          wabaId: datos.data?.waba_id,
          phoneNumberId: datos.data?.phone_number_id,
          coexistencia: datos.event === "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING",
        };
        completar();
        return;
      }

      if (datos.event === "CANCEL") {
        parcial.current = {};
        onError(`Cancelaste en el paso: ${datos.data?.current_step ?? "desconocido"}`);
        return;
      }

      if (datos.event === "ERROR") {
        parcial.current = {};
        onError(datos.data?.error_message || "Meta devolvió un error en el alta");
      }
    };

    window.addEventListener("message", alRecibir);
    return () => window.removeEventListener("message", alRecibir);
  }, [completar, onError]);

  return useCallback(async () => {
    try {
      const platform = await fetchMetaPlatform();
      const FB = await initMetaApp({ appId: platform.whatsappAppId, version: platform.version });

      FB.login(
        (respuesta) => {
          const code = respuesta?.authResponse?.code;

          if (!code) {
            return;
          }

          parcial.current = { ...parcial.current, code };
          completar();
        },
        {
          config_id: platform.whatsappConfigId,
          response_type: "code",
          override_default_response_type: true,
          extras: { setup: {} },
        }
      );
    } catch (err) {
      onError(err.message);
    }
  }, [completar, onError]);
};

export default useEmbeddedSignup;
